import {
    useEffect,
    useState,
} from 'react';

import {
    useDispatch,
    useSelector,
} from 'react-redux';
import { PermissionAction } from 'src/actions/permission.acction';
import { Simdata5gAction } from 'src/actions/simdata5g.action';

import {
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    FormControlLabel,
    FormGroup,
    TextField,
    Typography,
    Grid,
    Box,
    Select as Select1,
    InputAdornment,
    SvgIcon,
    MenuItem,
} from '@material-ui/core';

import { Search as SearchIcon } from 'react-feather';

import {
    DatePicker,
    LocalizationProvider,
  } from '@mui/x-date-pickers';
  import {
    DEFAULT_ROW_PER_PAGE,
    POST_EDITOR_FONTS,
    POST_EDITOR_FONT_SIZES,
  } from 'src/utils/constants';
  import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import moment from 'moment';

import PostEditor from "../../components/PostEditor";
import ImageUploader from "../../components/ImageUploader";

const CreateEditDialog = (props) => {
    const dispatch = useDispatch()
    const [selectedPermissionIds, setSelectedPermissionIds] = useState([]);
    const { role } = useSelector(state => state.profile);
    const { items } = useSelector(state => state.permission)
    const { selected } = useSelector(state => state.simdata5g)

    const [name, setName] = useState("");
    const [image, setImage] = useState("");
    const [price, setPrice] = useState(0);
    const [price_new, setPriceNew] = useState(0);
    const [operator, setOperator] = useState("-99");
    const [time_by_month, setTimeByMonth] = useState("-99");
    const [description, setDescription] = useState("");
    const [trang_thai, setTrangThai] = useState("con_sim")

    const handleImageUpload = (imageUrl) => {
        setImage(imageUrl);
    };

    useEffect(() => {
        if (items.length > 0) {
            return;
        }
        dispatch(PermissionAction.list(0, 100))
    }, [])

    useEffect(() => {
        if (props.type === 'EDIT') {
            if (selected) {
                setName(selected.name)
                setImage(selected.image)
                setPrice(selected.price)
                setPriceNew(selected.price_new)
                setOperator(selected.operator)
                setTimeByMonth(selected.time_by_month)
                setDescription(selected.description)
                setTrangThai(selected.trang_thai)
            }
        }
    }, [selected])

    const onPressPositive = async () => {
        console.log("image:", image);
        console.log("description:", description);

        if (name === "") {
            alert("Những trường * là bắt buộc");
            return;
        }
        if (image === "") {
            alert("Những trường * là bắt buộc");
            return;
        }
        if (price === "") {
            alert("Những trường * là bắt buộc");
            return;
        }
        if (operator === "" || operator == "-99") {
            alert("Những trường * là bắt buộc");
            return;
        }
        if (time_by_month === "" || time_by_month == "-99") {
            alert("Những trường * là bắt buộc");
            return;
        }
        if (description === "") {
            alert("Những trường * là bắt buộc");
            return;
        }
        if (trang_thai === "" || trang_thai == "-99") {
            alert('Vui lòng chọn trạng thái!');
            return;
        }
        if (props.type === 'EDIT') {
            dispatch(Simdata5gAction.update(selected.id, { 
                name,
                image, 
                price,
                price_new,
                operator, 
                time_by_month,
                description,
                trang_thai,
            }))
            resetState();
            props.handleClose();
        } else {
            try {
                const response = await dispatch(Simdata5gAction.create({ 
                    name,
                    image, 
                    price,
                    price_new,
                    operator, 
                    time_by_month,
                    description,
                    trang_thai,
                }))
                resetState();
                props.handleClose();
            } catch (error) {
                if (typeof error.code !== 'undefined' && typeof error.msg !== 'undefined') alert("[Lỗi]\n"+error.msg)
            }
        }
        
    }

    const resetState = () => {
        setName("")
        setImage("")
        setPrice(0)
        setPriceNew(0)
        setOperator("-99")
        setTimeByMonth("-99")
        setDescription("")
        setTrangThai("con_sim")
    }

    const handleSelectOne = (event, id) => {
        const selectedIndex = selectedPermissionIds.indexOf(id);
        let newSelectedCustomerIds = [];
        if (selectedIndex === -1) {
            newSelectedCustomerIds = newSelectedCustomerIds.concat(selectedPermissionIds, id);
        } else if (selectedIndex === 0) {
            newSelectedCustomerIds = newSelectedCustomerIds.concat(selectedPermissionIds.slice(1));
        } else if (selectedIndex === selectedPermissionIds.length - 1) {
            newSelectedCustomerIds = newSelectedCustomerIds.concat(selectedPermissionIds.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelectedCustomerIds = newSelectedCustomerIds.concat(
                selectedPermissionIds.slice(0, selectedIndex),
                selectedPermissionIds.slice(selectedIndex + 1)
            );
        }
        setSelectedPermissionIds(newSelectedCustomerIds);
    };

    const setColor = (value) => {
        if (value == 'MOBIFONE') return 'green';
        else if (value == 'VINAPHONE') return 'blue';
        else if (value == 'VIETTEL') return 'red';
        else return '#000000';
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Dialog open={props.open} onClose={props.handleClose}>
                <DialogTitle>{props.type === 'EDIT' ? "Cập nhật bản ghi" : "Tạo bản ghi mới"}</DialogTitle>
                <DialogContent style={{ width: 600, paddingTop: 20 }}>
                    <Grid
                        container
                        spacing={3}
                    >
                        <Grid
                            item
                            md={6}
                            xs={6}
                        >
                            <TextField
                                fullWidth
                                label="Tên"
                                name="name"
                                onChange={(e) => setName(e.target.value)}
                                required
                                value={name}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid
                            item
                            md={6}
                            xs={6}
                        >
                            <Select1
                                style={{ height: 56, marginTop: 0, marginBottom: 0, width: "100%", marginLeft: 0 }}
                                name="trang_thai"
                                value={trang_thai || -99}
                                onChange={(e) => setTrangThai(e.target.value)}
                                variant="outlined"
                                startAdornment={(
                                    <InputAdornment position="start">
                                    <SvgIcon fontSize="small" color="action">
                                        <SearchIcon />
                                    </SvgIcon>
                                    </InputAdornment>
                                )}
                                >
                                <MenuItem value="-99">Trạng thái...</MenuItem>
                                <MenuItem value="con_sim">Còn hàng</MenuItem>
                                <MenuItem value="da_ban">Hết hàng</MenuItem>
                            </Select1>
                        </Grid>
                        <Grid
                            item
                            md={12}
                            xs={12}
                        >
                            <Typography
                                className='checkbox-container'
                                variant="body1"
                            >
                                Hình ảnh *
                            </Typography>
                            <div style={{width: "100%"}}>
                                <ImageUploader 
                                    onUploadSuccess={handleImageUpload} 
                                    initialImage={image !== "" ? image : ""}
                                />
                            </div>
                        </Grid>
                        <Grid
                            item
                            md={6}
                            xs={6}
                        >
                            <TextField
                                fullWidth
                                label="Giá"
                                name="price"
                                onChange={(e) => setPrice(e.target.value)}
                                required
                                value={price}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid
                            item
                            md={6}
                            xs={6}
                        >
                            <TextField
                                fullWidth
                                label="Giá khuyến mãi"
                                name="price_new"
                                onChange={(e) => setPriceNew(e.target.value)}
                                value={price_new}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid
                            item
                            md={6}
                            xs={6}
                        >
                            <Select1
                                style={{ height: 56, marginTop: 0, marginBottom: 0, width: "100%", marginLeft: 0 }}
                                name="operator"
                                value={operator || -99}
                                onChange={(e) => setOperator(e.target.value)}
                                variant="outlined"
                                startAdornment={(
                                    <InputAdornment position="start">
                                    <SvgIcon fontSize="small" color="action">
                                        <SearchIcon />
                                    </SvgIcon>
                                    </InputAdornment>
                                )}
                                >
                                <MenuItem value="-99">Nhà mạng...</MenuItem>
                                <MenuItem value="MOBIFONE" style={{color: setColor('MOBIFONE')}}>MOBIFONE</MenuItem>
                                <MenuItem value="VINAPHONE" style={{color: setColor('VINAPHONE')}}>VINAPHONE</MenuItem>
                                <MenuItem value="VIETTEL" style={{color: setColor('VIETTEL')}}>VIETTEL</MenuItem>
                            </Select1>
                        </Grid>
                        <Grid
                            item
                            md={6}
                            xs={6}
                        >
                            <Select1
                                style={{ height: 56, marginTop: 0, marginBottom: 0, width: "100%", marginLeft: 0 }}
                                name="time_by_month"
                                value={time_by_month || -99}
                                onChange={(e) => setTimeByMonth(e.target.value)}
                                variant="outlined"
                                startAdornment={(
                                    <InputAdornment position="start">
                                    <SvgIcon fontSize="small" color="action">
                                        <SearchIcon />
                                    </SvgIcon>
                                    </InputAdornment>
                                )}
                                >
                                <MenuItem value="-99">Thời hạn theo tháng...</MenuItem>
                                <MenuItem value="1" style={{color: setColor('')}}>1 tháng</MenuItem>
                                <MenuItem value="3" style={{color: setColor('')}}>3 tháng</MenuItem>
                                <MenuItem value="6" style={{color: setColor('')}}>6 tháng</MenuItem>
                                <MenuItem value="12" style={{color: setColor('')}}>12 tháng</MenuItem>
                                <MenuItem value="24" style={{color: setColor('')}}>24 tháng</MenuItem>
                            </Select1>
                        </Grid>
                        <Grid
                            item
                            md={12}
                            xs={12}
                        >
                            <Typography
                                className='checkbox-container'
                                variant="body1"
                            >
                                Mô tả *
                            </Typography>
                            <div>
                                <PostEditor
                                    onChange={(value) => {
                                        setDescription(value);
                                    }}
                                    initialContent={description !== "" ? description : ""}
                                />
                            </div>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={props.handleClose}>Huỷ</Button>
                    <Button onClick={onPressPositive}>{props.type === 'EDIT' ? "Cập nhật" : "Tạo"}</Button>
                </DialogActions>
            </Dialog >
        </LocalizationProvider>
    );
}

export default CreateEditDialog;